import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { isEqual } from "lodash-es";
import { map } from "rxjs/operators";

import { ProductBlockAction } from "../product-block/product-block.action";
import { ProductBlock } from "../product-block/product-block.model";

import { SportsbookBlockAction } from "./sportsbook-block.action";
import { SportsbookBlockUpdate } from "./sportsbook-block.model";

@Injectable()
export class SportsbookBlockEffect {
	update$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ProductBlockAction.getSuccess, ProductBlockAction.updateSuccess),
			map((payload) => SportsbookBlockAction.update(this.getSportsbookBlockFromProductBlock(payload.products)))
		)
	);

	clear$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ProductBlockAction.clear),
			map(() => SportsbookBlockAction.clear())
		)
	);

	constructor(private actions$: Actions) {}

	private getSportsbookBlockFromProductBlock(products: ProductBlock[]): SportsbookBlockUpdate {
		return {
			isSportsbookBlocked: isEqual(
				products.filter((product) => product.isBlocked).map((product) => product.classificationName),
				["Sportsbook"]
			),
			isPlayerProfileSelected:
				new Date(Math.max(...products.map((e) => new Date(e.lastModified!).getTime()))) >
				new Date("2020-06-01T00:00:00"),
		};
	}
}
